function formatMoney(value) {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return "To be confirmed";
    }

    return `$${Number(value).toLocaleString("en-US")} CAD`;
}

function formatDimensions(dimensions) {
    if (!dimensions) return "—";

    const width = Number(dimensions.width);
    const height = Number(dimensions.height);

    if (!width || !height) return "—";

    return `${width}" × ${height}"`;
}


export default function AiQuotationPreview({ aiText }) {
    if (!aiText?.signs?.length) return null;

    const subtotal =
        aiText.signs.reduce(
            (sum, s) => sum + (Number(s.costBeforeTax) || 0),
            0
        ) +
        (aiText.installation?.required
            ? Number(aiText.installation.costBeforeTax) || 0
            : 0);

    const gst = subtotal * 0.05;
    const qst = subtotal * 0.09975;
    const totalTax = gst + qst;
    const total = subtotal + totalTax;

    return (
        <div className="ai-preview">
            <div className="ai-preview-title">
                Preliminary quotation preview
            </div>

            <div className="ai-quote-box">
                <p className="ai-quote-note">
                    Preliminary estimate. Final pricing may vary by approximately ±15% after
                    technical review, site survey, engineering, final artwork approval,
                    materials and installation conditions.
                </p>

                {aiText.signs.map((sign) => (
                    <div key={sign.signNumber} className="ai-quote-sign">
                        <h3>
                            SIGN {sign.signNumber} — {(sign.type || "").toUpperCase()}
                        </h3>

                        {!!sign.reference && (
                            <div className="ai-sign-reference">
                                Reference: {sign.reference}
                            </div>
                        )}

                        <div className="ai-spec-row">
                            <span>Estimated Dimensions</span>
                            <strong>{formatDimensions(sign.estimatedDimensions)}</strong>
                        </div>

                        <div className="ai-spec-row">
                            <span>Estimated Price</span>
                            <strong>{formatMoney(sign.costBeforeTax)}</strong>
                        </div>

                        {!!sign.costNote && (
                            <p className="ai-quote-included">
                                Scope: {sign.costNote}
                            </p>
                        )}
                    </div>
                ))}

                {aiText.installation?.required && (
                    <div className="ai-quote-sign">
                        <h3>INSTALLATION</h3>

                        <div className="ai-spec-row">
                            <span>Estimated Installation</span>
                            <strong>{formatMoney(aiText.installation.costBeforeTax)}</strong>
                        </div>

                        {!!aiText.installation.note && (
                            <p className="ai-quote-included">
                                Scope: {aiText.installation.note}
                            </p>
                        )}
                    </div>
                )}

                <div className="ai-quote-total">
                    <h3>PROJECT TOTAL</h3>

                    <div className="ai-spec-row">
                        <span>Subtotal before tax</span>
                        <strong>{formatMoney(subtotal)}</strong>
                    </div>

                    <div className="ai-spec-row ai-tax-row">
                        <span>GST (5%)</span>
                        <strong>{formatMoney(gst)}</strong>
                    </div>

                    <div className="ai-spec-row ai-tax-row">
                        <span>QST (9.975%)</span>
                        <strong>{formatMoney(qst)}</strong>
                    </div>

                    {/* <div className="ai-spec-row">
                        <span>Total tax</span>
                        <strong>{formatMoney(totalTax)}</strong>
                    </div> */}

                    <div className="ai-spec-row ai-spec-total">
                        <span>Total including tax</span>
                        <strong>{formatMoney(total)}</strong>
                    </div>
                </div>

                {!!aiText.disclaimer && (
                    <p className="ai-quote-disclaimer">
                        {aiText.disclaimer}
                    </p>
                )}
            </div>
        </div>
    );
}

// export default function AiQuotationPreview({ aiText }) {

//     if (!aiText?.signs?.length) return null;

//     return (
//         <div className="ai-preview">

//             <div className="ai-preview-title">
//                 Preliminary quotation preview
//             </div>

//             <div className="ai-quote-box">

//                 <p className="ai-quote-note">
//                     Preliminary estimate. Final pricing may vary by approximately ±15% after
//                     technical review, site survey, engineering, final artwork approval,
//                     materials and installation conditions.
//                 </p>

//                 {aiText.signs.map((sign) => (

//                     <div
//                         key={sign.signNumber}
//                         className="ai-quote-sign"
//                     >

//                         <h3>
//                             SIGN {sign.signNumber} — {(sign.type || "").toUpperCase()}
//                         </h3>

//                         <div className="ai-spec-row">
//                             <span>Estimated Dimensions</span>
//                             <strong>
//                                 {formatDimensions(sign.estimatedDimensions)}
//                             </strong>
//                         </div>

//                         <div className="ai-spec-row">
//                             <span>Artwork Cut Length (LOC)</span>
//                             <strong>
//                                 {sign.artworkCutLength || "—"}
//                             </strong>
//                         </div>

//                         <div className="ai-spec-row">
//                             <span>Estimated Price (tax included)</span>
//                             <strong>
//                                 {formatMoney(sign.costWithTax)}
//                             </strong>
//                         </div>

//                         {!!sign.costNote && (

//                             <p className="ai-quote-included">
//                                 Scope: {sign.costNote}
//                             </p>

//                         )}

//                     </div>

//                 ))}

//                 {aiText.installation?.required && (

//                     <div className="ai-quote-sign">

//                         <h3>INSTALLATION</h3>

//                         <div className="ai-spec-row">
//                             <span>Estimated Installation (before tax)</span>

//                             <strong>
//                                 {formatMoney(aiText.installation.costBeforeTax)}
//                             </strong>
//                         </div>

//                         {/* <div className="ai-spec-row">
//                             <span>Estimated Installation (tax included)</span>

//                             <strong>
//                                 {formatMoney(aiText.installation.costWithTax)}
//                             </strong>
//                         </div> */}

//                         {!!aiText.installation.note && (

//                             <p className="ai-quote-included">
//                                 Scope: {aiText.installation.note}
//                             </p>

//                         )}

//                         {(() => {

//                             const subtotal =
//                                 aiText.signs.reduce(
//                                     (sum, s) => sum + (Number(s.costBeforeTax) || 0),
//                                     0
//                                 ) +
//                                 (aiText.installation?.required
//                                     ? Number(aiText.installation.costBeforeTax) || 0
//                                     : 0);

//                             const gst = subtotal * 0.05;
//                             const qst = subtotal * 0.09975;
//                             const totalTax = gst + qst;
//                             const total = subtotal + totalTax;

//                             return (

//                                 <div className="ai-quote-total">

//                                     <h3>PROJECT TOTAL</h3>

//                                     <div className="ai-spec-row">
//                                         <span>Subtotal before tax</span>
//                                         <strong>{formatMoney(subtotal)}</strong>
//                                     </div>

//                                     <div className="ai-spec-row">
//                                         <span>GST (5%)</span>
//                                         <strong>{formatMoney(gst)}</strong>
//                                     </div>

//                                     <div className="ai-spec-row">
//                                         <span>QST (9.975%)</span>
//                                         <strong>{formatMoney(qst)}</strong>
//                                     </div>

//                                     <div className="ai-spec-row">
//                                         <span>Total tax</span>
//                                         <strong>{formatMoney(totalTax)}</strong>
//                                     </div>

//                                     <div
//                                         className="ai-spec-row ai-spec-total"
//                                     >
//                                         <span>Total including tax</span>
//                                         <strong>{formatMoney(total)}</strong>
//                                     </div>

//                                 </div>

//                             );

//                         })()}

//                     </div>

//                 )}

//                 {!!aiText.disclaimer && (

//                     <p className="ai-quote-disclaimer">
//                         {aiText.disclaimer}
//                     </p>

//                 )}

//             </div>

//         </div>
//     );
// }